<p-dialog #woundlocationdialog
  appendTo="body"
  [(visible)]="showModal"
  [draggable]="false"
  [style]="{ width: '40rem' }"
  [resizable]="false"
  (onHide)="close()">
  <ng-template #header>
    <span>{{ item ? 'Edit' : 'New' }} Wound Location</span>
  </ng-template>
  @if (formModel) {
    <p-fluid>
    <form [formGroup]="formModel">
      <div class="field">
        <div class="p-field-value">
          <input pInputText formControlName="locationNote">
        </div>
      </div>
    </form>
    </p-fluid>
  }
  <ng-template #footer>
    <button pButton class="p-button-info mr-2" label="Cancel" (click)="close()"></button>
    <button pButton label="{{ item ? 'Update' : 'Add' }}" [disabled]="formModel.invalid" (click)="onSubmit()"></button>
  </ng-template>
</p-dialog>
